import { Observable, Subject } from 'rxjs';
import * as i0 from "@angular/core";
var MediatorService = /** @class */ (function () {
    function MediatorService() {
        this.planObject = null;
        this.planObjectReady = new Subject();
    }
    MediatorService.prototype.getPlanObjectReady = function () {
        return this.planObjectReady.asObservable();
    };
    MediatorService.prototype.raiseConfigReadyEvent = function (planObj) {
        this.planObject = planObj;
        this.planObjectReady.next(planObj);
    };
    MediatorService.prototype.getObservable = function (key, val) {
        var _this = this;
        // key = 'stageApp';
        return new Observable(function (observer) {
            if (_this.planObject) {
                _this.planObject.hasOwnProperty(key) ? observer.next(_this.planObject[key] === val) : observer.next(false);
            }
            else {
                var subscription_1 = _this.getPlanObjectReady().subscribe(function (planObject) {
                    if (planObject.hasOwnProperty(key)) {
                        observer.next(planObject[key] === val);
                    }
                    else {
                        observer.next(false);
                    }
                    subscription_1.unsubscribe();
                    subscription_1 = null;
                });
            }
        });
    };
    MediatorService.ngInjectableDef = i0.defineInjectable({ factory: function MediatorService_Factory() { return new MediatorService(); }, token: MediatorService, providedIn: "root" });
    return MediatorService;
}());
export { MediatorService };
